<template>
  <div>
    <v-row>
      <v-col cols="12">
        <validation-provider v-slot="{ errors }" rules="required">
          <v-text-field id="nome-importador-dados" v-model="nome" class="my-0" label="Nome" outlined :error-messages="errors" />
        </validation-provider>
      </v-col>

      <v-col cols="12">
        <validation-provider v-slot="{ errors }" rules="required">
          <v-select
            id="layout-importador-dados"
            :value="layoutSlug"
            :items="layoutItems"
            label="Tipo de Importação"
            outlined
            :error-messages="errors"
            :loading="layoutsCarregando"
            no-data-text="Nenhum layout disponível"
            @change="setLayout($event)"
          />
        </validation-provider>
      </v-col>

      <v-col cols="12">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header id="arquivo-importador-dados">
              <span style="font-size: 15px !important">Arquivo CSV</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content eager>
              <v-row>
                <v-col cols="12">
                  <v-alert v-if="layoutCabecalho.length" dense outlined type="info" color="blue">
                    <div>
                      <a href="javascript:void(0)" @click="downloadArquivoModelo()">Clique aqui</a>
                      para baixar o arquivo modelo para a importação.
                      <br />
                      O arquivo deve conter as seguintes colunas:
                      <b>{{ layoutCabecalho.join(', ') }}</b>
                      (exatamente nessa ordem e com esses nomes).
                      <br />
                      OBS: O arquivo enviado precisa estar no formato
                      <b>UTF-8</b>
                      .
                    </div>
                  </v-alert>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <validation-provider v-slot="{ errors }" rules="required">
                    <v-file-input
                      v-model="arquivoFileObj"
                      label="Arquivo CSV"
                      placeholder="Selecione um arquivo CSV"
                      outlined
                      accept=".csv"
                      truncate-length="30"
                      :loading="arquivoUploading"
                      loader-height="4"
                      :success="arquivoId && arquivoFileObj ? true : false"
                      :error-messages="errors"
                      :disabled="!layoutSlug"
                      @change="uploadNewFile($event)"
                      @click:clear="clearArquivo()"
                    />
                  </validation-provider>
                  <validation-provider rules="required">
                    <input type="hidden" name="validate-upload-arquivo-csv" :value="arquivoId" />
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row class="mb-n5 mt-n2">
                <parametros-arquivo-csv
                  :delimitador.sync="arquivoDelimitador"
                  :involucro.sync="arquivoInvolucro"
                  :escape.sync="arquivoEscape"
                />
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import ArquivosService from '@/services/ArquivosService';
  import ImportadorDadosService from '@/services/ImportadorDadosService';

  export default {
    components: {
      ParametrosArquivoCsv: () => import('@/components/general/GeneralParametrosArquivoCsv.vue')
    },

    data: () => ({
      layouts: [],
      layoutsCarregando: false
    }),

    computed: {
      nome: {
        get() {
          return this.$store.state.importadorDados.nome;
        },
        set(value) {
          this.$store.dispatch('setImportadorDados', { nome: value });
        }
      },
      layoutSlug: {
        get() {
          return this.$store.state.importadorDados.layoutSlug;
        }
      },
      layoutCabecalho: {
        get() {
          return this.$store.state.importadorDados.layoutCabecalho;
        }
      },
      arquivoId: {
        get() {
          return this.$store.state.importadorDados.arquivo.id;
        },
        set(value) {
          this.$store.dispatch('setImportadorDados', { arquivo: { id: value } });
        }
      },
      arquivoFileObj: {
        get() {
          return this.$store.state.importadorDados.arquivo.fileObj;
        },
        set(value) {
          this.$store.dispatch('setImportadorDados', { arquivo: { fileObj: value } });
        }
      },
      arquivoUploading: {
        get() {
          return this.$store.state.importadorDados.arquivo.uploading;
        },
        set(value) {
          this.$store.dispatch('setImportadorDados', { arquivo: { uploading: value } });
        }
      },
      arquivoDelimitador: {
        get() {
          return this.$store.state.importadorDados.arquivo.delimitador;
        },
        set(value) {
          this.$store.dispatch('setImportadorDados', { arquivo: { delimitador: value } });
        }
      },
      arquivoInvolucro: {
        get() {
          return this.$store.state.importadorDados.arquivo.involucro;
        },
        set(value) {
          this.$store.dispatch('setImportadorDados', { arquivo: { involucro: value } });
        }
      },
      arquivoEscape: {
        get() {
          return this.$store.state.importadorDados.arquivo.escape;
        },
        set(value) {
          this.$store.dispatch('setImportadorDados', { arquivo: { escape: value } });
        }
      },
      layoutItems() {
        return this.layouts.map((l) => ({ text: l.nome, value: l.slug }));
      }
    },

    created() {
      this.getLayouts();
    },

    methods: {
      getLayouts() {
        this.layoutsCarregando = true;

        ImportadorDadosService.getLayouts()
          .then((response) => {
            this.layouts = response.data.data ?? response.data.layouts ?? response.data;
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao recuperar os layouts disponíveis.', '', { position: 'topRight' });
          })
          .finally(() => (this.layoutsCarregando = false));
      },

      setLayout(layoutSlug) {
        const layout = this.layouts.find((l) => l.slug === layoutSlug);
        this.$store.dispatch('setImportadorDados', {
          layoutSlug,
          layoutCabecalho: layout ? layout.cabecalho : []
        });
        this.clearArquivo();
      },

      exportData() {
        const vuexData = this.$store.state.importadorDados;

        return {
          nome: vuexData.nome,
          layout_slug: vuexData.layoutSlug,
          arquivo_id: vuexData.arquivo.id,
          arquivo_delimitador: vuexData.arquivo.delimitador,
          arquivo_involucro: vuexData.arquivo.involucro,
          arquivo_escape: vuexData.arquivo.escape
        };
      },

      uploadNewFile(arquivo) {
        if (!arquivo) {
          this.clearArquivo();
          return;
        }

        this.arquivoId = '';
        this.arquivoUploading = true;

        const formDataWithFile = new FormData();
        formDataWithFile.append('file', arquivo);

        ArquivosService.uploadFile(formDataWithFile, {})
          .then(async (response) => {
            await this.validaHeader(
              response.data.arquivoId,
              this.arquivoDelimitador,
              this.arquivoInvolucro,
              this.arquivoEscape,
              this.layoutCabecalho
            );
            this.arquivoId = response.data.arquivoId;
          })
          .catch((err) => {
            if (err?.data?.error_code == 120 || err?.data?.error_code == 121) {
              this.$toast.error(err.data.erro, '', { position: 'topRight', timeout: 6000 });
            } else {
              this.$toast.error('Erro no upload do arquivo.', '', { position: 'topRight' });
              console.error('Erro ao fazer upload: ', err);
            }
            this.arquivoFileObj = null;
          })
          .finally(() => (this.arquivoUploading = false));
      },

      validaHeader(arquivoId, delimitador, involucro, escape, cabecalhoEsperado) {
        return ArquivosService.validarHeaderCSV(arquivoId, {
          delimitador,
          involucro,
          escape,
          cabecalhoEsperado
        }).catch((err) => {
          throw err;
        });
      },

      downloadArquivoModelo() {
        this.$toast.info('Processando...', '', { position: 'topRight', timeout: 1250 });

        ImportadorDadosService.baixarArquivoModelo(this.layoutSlug)
          .then(async (res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `arquivo_modelo_${this.layoutSlug}.csv`);
            document.body.appendChild(link);
            link.click();
          })
          .catch((err) => {
            this.$toast.error('Erro ao baixar o arquivo modelo.', '', { position: 'topRight' });
            console.error(err);
          });
      },

      clearArquivo() {
        this.arquivoId = '';
        this.arquivoFileObj = null;
        this.arquivoDelimitador = ';';
        this.arquivoInvolucro = '"';
        this.arquivoEscape = '"';
        this.$forceUpdate();
      }
    }
  };
</script>
